import { render, staticRenderFns } from "./InqueryDetail.vue?vue&type=template&id=25d2b1a3&"
import script from "./InqueryDetail.vue?vue&type=script&lang=js&"
export * from "./InqueryDetail.vue?vue&type=script&lang=js&"
import style0 from "./InqueryDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports